module.exports = __webpack_public_path__ + "img/aa_pic_youhuiquan@2x.df4083a3.png";